;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Link from "next/link"
import ZestLifeIconLemonDotsInCircle from "../../../icons/ZestLifeIconLemonDotsInCircle"
import ZestLifeName from "../../../icons/ZestLifeName"

export default function ZestLifeLogo({ isWhite: _isWhite }: { isWhite?: boolean }) {
  return (
    <div className="grow flex items-center">
      <Link href="/" className="flex items-center gap-2" aria-label="ZestLife Home">
        {/* Icon - hidden on mobile, shown on desktop */}
        <div className="hidden min-[900px]:block">
          <ZestLifeIconLemonDotsInCircle />
        </div>

        {/* Name - always visible */}
        <div>
          <ZestLifeName />
        </div>
      </Link>
    </div>
  )
}
